import { IAssetThirdPartyConstraint } from '../../interfaces/iasset-third-party-constraint';
import { Asset } from '../asset';
import { CapacityType } from '../capacity-type';
import { ThirdPartyConstraintType } from '../third-party-constraint-type';
import { UnitOfMeasure } from '../unit-of-measure';

export class AssetThirdPartyConstraintBase {
  AssettThirdPartyConstraintId: number;
  AssetId: number | null;
  ThirdPartyConstraintTypeId: number | null;
  CapacityTypeId: number | null;
  Capacity: number | null;
  UnitOfMeasureId: number | null;
  Created: Date | null;
  CreatedBy: string | null;
  Updated: Date | null;
  UpdatedBy: string | null;

  Asset?: Asset;
  CapacityType?: CapacityType;
  ThirdPartyConstraintType?: ThirdPartyConstraintType;
  UnitOfMeasure?: UnitOfMeasure;

  constructor(item?: IAssetThirdPartyConstraint) {
    if (item) {

      this.AssettThirdPartyConstraintId = item.AssettThirdPartyConstraintId;
      this.AssetId = item.AssetId;
      this.ThirdPartyConstraintTypeId = item.ThirdPartyConstraintTypeId;
      this.CapacityTypeId = item.CapacityTypeId;
      this.Capacity = item.Capacity;
      this.UnitOfMeasureId = item.UnitOfMeasureId;
      this.Created = item.Created ? new Date(item.Created) : null;
      this.CreatedBy = item.CreatedBy;
      this.Updated = item.Updated ? new Date(item.Updated) : null;
      this.UpdatedBy = item.UpdatedBy;

      this.Asset = new Asset(item.Asset);
      this.CapacityType = new CapacityType(item.CapacityType);
      this.ThirdPartyConstraintType = new ThirdPartyConstraintType(item.ThirdPartyConstraintType);
      this.UnitOfMeasure = new UnitOfMeasure(item.UnitOfMeasure);
    }
  }
}